{
  "login": {
    "title": "Connexion",
    "subtitle": "Console SOC Ward³",
    "email": "Email",
    "email_placeholder": "vous@exemple.com",
    "password": "Mot de passe",
    "password_placeholder": "Votre mot de passe",
    "submit": "Se connecter",
    "submitting": "Connexion…",
    "error_invalid": "Email ou mot de passe incorrect",
    "error_server": "Erreur serveur — veuillez réessayer",
    "error_oidc": "Échec de la connexion SSO",
    "use_oidc": "Se connecter avec {{provider}}",
    "use_local": "Ou se connecter avec votre mot de passe",
    "tenant_scope": "Tenant {{tenant}} chez MSSP {{mssp}}",
    "mssp_scope": "MSSP {{mssp}}",
    "no_scope": "Aucune portée tenant détectée",
    "mssp_slug_label": "MSSP slug (optionnel)",
    "mssp_slug_placeholder": "acme-security",
    "tenant_slug_label": "Tenant slug (optionnel)",
    "tenant_slug_placeholder": "bank-eu-1",
    "sso_button_default": "Se connecter avec le SSO",
    "sso_divider": "ou local",
    "break_glass_prefix": "Tu peux forcer l'auth locale (break-glass) via",
    "break_glass_suffix": ".",
    "oidc_mssp_required": "MSSP slug requis pour OIDC.",
    "generic_failure": "Connexion impossible"
  },
  "logout": {
    "button": "Déconnexion",
    "title": "Se déconnecter de cette session"
  },
  "profile": {
    "title": "Profil",
    "subtitle": "Préférences du compte",
    "email": "Email",
    "role": "Rôle",
    "scope": "Portée",
    "language": "Langue de l'interface",
    "language_help": "Appliqué immédiatement. Sauvegardé sur votre compte.",
    "save_error": "Impossible d'enregistrer votre préférence — veuillez réessayer",
    "back_to_app": "Retour au tableau de bord"
  },
  "status": {
    "authenticating": "Authentification…",
    "system_nominal": "Système Nominal",
    "lstm_active": "LSTM Judge actif",
    "gnn_active": "GNN Judge actif",
    "shadow_active": "Shadow Mode collecte des flows",
    "user_uuid": "UUID utilisateur {{uuid}}",
    "open_navigation": "Ouvrir le menu",
    "close_navigation": "Fermer le menu",
    "expand_sidebar": "Déplier le menu",
    "collapse_sidebar": "Replier le menu"
  },
  "forbidden": {
    "admin_required": "Rôle admin requis",
    "platform_required": "Rôle Platform requis",
    "mssp_required": "Rôle MSSP requis",
    "role_not_allowed": "Le rôle {{role}} n'est pas autorisé ici"
  },
  "errors": {
    "forbidden_admin": "403 — cette console est réservée aux opérateurs platform / MSSP."
  }
}
